import { ProgramDescriptionAccordion } from '@components/buzzkuri/shared/uiParts/accordion/ProgramDescription'
import { Lecturer } from '@type/buzzkuri/programs-categor'
import React from 'react'
import { CategoryLecturersContent } from './Content'

type Props = {
  lecturers: Lecturer[]
}

export const CategoryLecturers = ({ lecturers }: Props): JSX.Element => (
  <div className="lg:w-[65.2vw]">
    <ProgramDescriptionAccordion title="講師情報">
      <CategoryLecturersContent {...{ lecturers }} />
    </ProgramDescriptionAccordion>
  </div>
)
